<template>
  <section class="customer-setting-row" :aria-label="title">
    <div class="setting-copy">
      <h4>{{ title }}</h4>
      <p>{{ description }}</p>
      <span v-if="status" class="setting-status">{{ status }}</span>
    </div>
    <div class="setting-action"><slot /></div>
    <div v-if="$slots.details" class="setting-details"><slot name="details" /></div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'CustomerSettingRow',
  props: {
    title: { type: String, required: true },
    description: { type: String, required: true },
    status: { type: String, default: undefined },
  },
})
</script>
